module.exports = __webpack_public_path__ + "img/web.edcd8fd0.svg";